<template>
  <div class="payment-page">
    <div class="card my-1 is-centered">
      <div class="card-content">

        <!-- <div class="pricing-table">
          <h3 class="pricing-title pro">Профессиональный</h3>
          <div class="price">900<sup>₽</sup><span style="font-size: 1rem;"> в месяц</span>
          </div>
          <div>
          <ul class="table-list">
            <li>Выбор адреса: ваше_название.savemenu.ru</li>
            <li>Push-уведомления</li>
            <li>Акции и анонсы</li>
            <li>Бронирование столов</li>
          </ul>
          </div>
                  </div>
          <div class="has-text-centered" style="margin-top: -25px;margin-bottom: 1rem;">
          <p>Для оплаты по счету обратитесь на <a href='mailto:hi@savemenu.ru'>hi@savemenu.ru</a></p>
          </div> -->
            <h3 class="title is-4">Оплата</h3>
        <div class="payment">
          <div class="card">
            <div class="card-header level is-marginless" style="padding:0.75rem;">
              <div class="level-left"><span class="level-item">Тариф Стандартный (в месяц).</span></div>
              <div class="level-right"><span class="level-item">1800 руб</span></div>
            </div>
            <div class="card-header level is-marginless has-text-weight-semibold" style="padding:0.75rem;">
              <div class="level-left"><span class="level-item">Сумма к оплате сейчас: </span></div>
              <div class="level-right"><span class="level-item is-size-5">1800 руб</span></div>
            </div>
            <div class="has-background-white-ter dimmed" style="padding:0.5rem;">
              <div class="content">
                <p>Вы даете разрешение SaveMenu на списание вышеуказанной суммы. Последующие списания будут
                  производиться раз в 30 дней автоматически.
                  Вы можете остановить свою подписку в любой момент.<br />
                  Нажимая на кнопку "Перейти к оплате" вы подтверждаете, что ознакомились и согласны с нашей <a href="https://savemenu.ru/docs/security.pdf" target="_blank">Политикой
                    конфиденциальности</a>,
                  <a href="https://savemenu.ru/docs/terms_of_use.pdf" target="_blank">Пользовательским соглашением</a> и <a href="https://savemenu.ru/docs/oferta.pdf" target="_blank">Договором офертой</a>.
                </p>
              </div>
            </div>
          </div>
          <div class="level" style="margin-top: 2rem;margin-bottom: 0.5rem;">
            <div class="level-left"><img src="../assets/img/Uniteller_Visa_MasterCard_MIR.png" width="250px"></div>
            <div class="level-right">
              <router-link class="level-item has-text-grey" tag="a" to="/dashboard">Отмена</router-link>
              <p class="level-item"><a class="button upgrade" v-bind:class="{'is-loading':isLoading}" @click="openPaymentWindow">Перейти к оплате</a></p>
            </div>
          </div>
          <p><br></p>
          <div class="dimmed" style="text-align:center;">
            <a href="#" @click.prevent="showInfoBlock=!showInfoBlock" >Информация от Платежного Сервиса</a>
          </div>
          <div class="modal" v-bind:class="{'is-active':showInfoBlock}">
            <div class="modal-background" @click.prevent="showInfoBlock=!showInfoBlock"></div>
            <div class="modal-card">
               <header class="modal-card-head">
                <p class="modal-card-title"></p>
                <button class="delete" aria-label="close" @click.prevent="showInfoBlock=!showInfoBlock"></button>
              </header>
              <section class="modal-card-body">
              <h4 class="title is-4">Информация от Uniteller</h4>
              <p>Уважаемый клиент!
              </p>
              <p>
                <br>
              </p>
              <p>Вы можете оплатить свой заказ онлайн с помощью предложенных методов оплат через платежный сервис
                компании Uniteller. После подтверждения заказа Вы будете перенаправлены на защищенную платежную
                страницу Uniteller, где необходимо будет ввести данные для оплаты заказа.&nbsp;
              </p>
              <p>
                <br>
              </p>
              <p>
                После успешной оплаты на указанную в форме оплаты электронную почту будет направлен электронный чек с
                информацией о заказе и данными по произведенной оплате.&nbsp;
              </p>
              <p>
                <br>
              </p>
              <p>
                Если возникает необходимость возврата платежа, он производится на ту же карту, с которой производилась
                оплата.
              </p>
              <p>
                <br>
                 </p>
              <p>
                <strong>Гарантии безопасности</strong>
              </p>
              <p>
                <br>
              </p>
              <p>
                Безопасность процессинга Uniteller подтверждена сертификатом стандарта безопасности данных индустрии
                платежных карт PCI DSS. Надежность сервиса обеспечивается интеллектуальной системой мониторинга
                мошеннических операций, а также применением 3D Secure - современной технологией безопасности
                интернет-платежей.
              </p>
              <p>
                <br>
              </p>
              <p>
                Данные Вашей карты вводятся на специальной защищенной платежной странице. Передача информации в <a href="http://www.uniteller.ru/Info/ru/109">процессинговую
                  компанию</a> Uniteller происходит с применением технологии шифрования TLS. Дальнейшая передача
                информации осуществляется по закрытым банковским каналам, имеющим наивысший уровень надежности.
              </p>
              <p>
                <br>
              </p>
              <p>
                <strong><i>Uniteller не передает данные Вашей карты магазину и иным третьим лицам!</i> </strong>
              </p>
              <p>
                <br>
              </p>
              <p>
                Если Ваша карта поддерживает технологию 3D Secure, для осуществления платежа, Вам необходимо будет
                пройти дополнительную проверку пользователя в банке-эмитенте (банк, который выпустил Вашу карту). Для
                этого Вы будете направлены на страницу банка, выдавшего карту. Вид проверки зависит от банка. Как
                правило, это дополнительный пароль, который отправляется в SMS, карта переменных кодов, либо другие
                способы.
              </p>
              <p>
                <br>
              </p>
              <p>
                Если у Вас возникли вопросы по совершенному платежу, Вы можете обратиться в службу технической
                поддержки процессингового центра Uniteller: <a href="mailto:support@uniteller.ru">support@uniteller.ru</a>
                или по телефону <strong>8 800 100 19 60</strong>.
              </p>
              </section>
              <footer class="modal-card-foot">
                <button class="button is-success" @click.prevent="showInfoBlock=!showInfoBlock">Закрыть</button>
              </footer>
          </div>
          </div>
          </div>

        </div>
      </div>

  </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "../api";
import _ from "underscore";

export default {
  name: "Payment_ru",
  computed: _.extend(
    {},
    mapGetters({
      info: "getPlaceInfo",
      identityId: "getIdentityId"
    }),
    {}
  ),
  data() {
    return {
      showInfoBlock: false,
      isLoading: false
    };
  },
  methods: _.extend({}, mapActions(["populatePlaceInfo", "updatePlaceInfo"]), {
    openPaymentWindow: function() {
      this.isLoading = true;
      this.$ma.trackEvent({category: 'event', action: 'Payment initiated: Uniteller', label : null, value : null})
      let body = {
        Customer_IDP: this.identityId,
        email: this.info.email
      };
      api.getPaymentLink(body).then(response => {
        // this.isLoading = false
        window.onbeforeunload = function () {}
        window.open(response.data, "_self");
      });
    },
  trackModalopen: function() {
    this.$ma.trackEvent({category: 'event', action: 'Modal viewed: Payment gateway info', label : null, value : null})
  }
  }),
  mounted() {
        window.onbeforeunload = function () {}
    this.$title = this.$t('title') + " | " + this.$t('Payment.title')

    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})
  }
};
</script>



<style scoped>
/* Pricing */

.payment-page {
  padding-top: 0.5rem;
}

.pricing-table-title {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 2.6em;
  color: #fff;
  margin-top: 15px;
  text-align: left;
  margin-bottom: 25px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
}

.pricing-table-title a {
  font-size: 0.6em;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  width: 0;
  clear: both;
}

.pricing-wrapper {
  width: 680px;
  margin: 40px auto 0;
}

.pricing-table {
  margin: 0 auto 2rem auto;
  text-align: center;
  width: 80%;
  border-radius: 10px;
    -webkit-box-shadow: 0 2px 22px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
    box-shadow: 0 2px 22px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
    background-color: white;
}

.pricing-title {
  padding: 5px 0;
  font-size: 2em;
}

.pricing-title {
    text-transform: uppercase;
    padding: 1rem 0;
    font-size: 1.8em;
    border-radius: 10px 10px 0 0;
    background-color: #a193e5;
    color: white;
}

.is-centered {
  margin-left: auto;
  margin-right: auto;
}

.pricing-table .price {
  font-size: 2em;
  font-weight: 600;
  background: white;
  padding-top: 10px;
}

.pricing-table .price sup {
  font-size: 0.5em;
}

.table-list {
  background: #fff;
  color: #403d3a;
  text-align: left;
  display: inline-block;
  padding-bottom: 1rem;
}

.table-list li {
  padding: 8px 8px;
}

.table-list li:not(.empty):before {
  content: url("../../front/ru/_front/img/check.svg");
  color: #3fab91;
  display: inline-block;
  position: relative;
  right: 5px;
  font-size: 16px;
}

li .empty {
  padding: 30px;
  color: white;
}

.table-list li span {
  font-weight: 400;
}

.table-list li span.unlimited {
  color: #fff;
  background: #e95846;
  font-size: 0.9em;
  padding: 5px 7px;
  display: inline-block;
  -webkit-border-radius: 38px;
  -moz-border-radius: 38px;
  border-radius: 38px;
}
.payment{
  width: 700px; 
  margin: 0 auto;
}

@media only screen and (max-width: 768px) {
 .pricing-table {
   width: 100%;
 } 

 .payment{
  width: 100%; 
}
}
</style>
